import { Injectable } from '@angular/core';


declare let gtag: Function;

@Injectable()
export class GtagEvent {

    public emit( eventName: string, category: string, label: string = null, value: number = null ) {
        gtag( 'event', eventName, { category, label, value } );
    }

}